import React from 'react'
import { Link } from "react-router-dom";


const Gallery = () => {
    return (
        <>

            <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
                <div className="auto-container">
                    <h2>Gallery</h2>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li style={{ color: "green" }}>Gallery</li>
                    </ul>
                </div>
            </section>
            <section className="department-one" style={{ marginTop: "-60px" }}>
                <div className="department-one_image" style={{ backgroundImage: 'url(assets/images/background/1.jpg)' }} />
                <div className="auto-container">
                    <div className="sec-title light centered" style={{ marginTop: "-70px" }}>
                        <div className="sec-title_title">Our Gallery</div>
                        <h2 className="sec-title_heading">Our Departments Gallery</h2>
                    </div>
                    <div className="auto-container">
                        <div className="row clearfix">

                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_4.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInLeft" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_3.webp" alt /></Link>
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInUp" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_2.webp" alt /></Link>
                                    </div>
                                </div>
                            </div>

                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_5.jpeg" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_8.jpeg" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_7.jpeg" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Appendix.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Cancer stomach_2.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Parotid adenoma.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Cancer stomach.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Cancer stomach_1.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Lap cholecystectomy.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Cancer rectum.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Choledochal cyst.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Colonic perforation.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/GB Gangrene.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/LPJ for pancreatic stones.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Mucinous cystadeno carcinoma ovary.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Internal Hernia with intestinal obstruction.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Skin grafting for raw area.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Lateral supramalleolar flap for foot defect.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Gall stones.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Mesenteric cyst.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Hospital/Unknown.webp" alt /></Link>
                                    </div>
                                    <div className="about-one_button">
                                        {/* <a to="/Dr-av" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" style={{ textTransform: "capitalize", height: "18px", width: "270px", borderRadius: "90px" }} >
                                                <span style={{ borderRadius: "90px", fontSize:"18px" }} className="text-one">Parotid adenoma</span>
                                                <span className="text-two" style={{fontSize:"18px"}}>Parotid adenoma</span>
                                            </span>
                                        </a> */}
                                    </div>
                                </div>
                            </div>




                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_11.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_12.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_13.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_14.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_15.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_16.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_17.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_18.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_15.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_20.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_21.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_22.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>

                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_24.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_26.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_27.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_29.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_31.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_32.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                            <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                    <div className="news-block_one-image">
                                        <Link to="/gallery"><img src="assets/img/Gallery_35.webp" alt /></Link>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Gallery